import { render } from "./MensagensAutomaticas.vue?vue&type=template&id=afc21e76&scoped=true"
import script from "./MensagensAutomaticas.vue?vue&type=script&lang=js"
export * from "./MensagensAutomaticas.vue?vue&type=script&lang=js"

import "./MensagensAutomaticas.vue?vue&type=style&index=0&id=afc21e76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc21e76"]])

export default __exports__